import React, { Fragment } from 'react';
import { SketchPicker } from 'react-color';
import {
  UncontrolledPopover,
  InputGroup,
  InputGroupAddon,
  Input,
  FormGroup,
  Label,
} from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const IframeConstructorColorPicker = ({ value, id, onChange, name, label, validate }) => (
  <Fragment>
    <FormGroup>
      <Label for={id}>
        <FormattedMessage {...label} />
      </Label>
      <InputGroup>
        <InputGroupAddon addonType="prepend">
          <button
            className="ic-color-picker-popover-toggler"
            id={id}
            style={{
              background: value,
            }}
          />
        </InputGroupAddon>
        <Input
          value={value}
          onChange={onChange}
          onBlur={validate}
          name={name}
          bsSize="sm"
          className="color-picker-input"
        />
      </InputGroup>
    </FormGroup>

    <UncontrolledPopover
      className="ic-color-picker-popover"
      placement="auto"
      target={id}
      trigger="legacy"
    >
      <SketchPicker onChangeComplete={e => onChange(e, name)} color={value} disableAlpha={true} />
    </UncontrolledPopover>
  </Fragment>
);

export default IframeConstructorColorPicker;
